module.exports = __webpack_public_path__ + "static/media/water quality.3fb9c699.jpg";